import * as React from "react";

function SvgSeg(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 81 81.105"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <path
        fill="#5EA091"
        d="M81.399 39.309l-.02-.239h-.001a17.6 17.6 0 01-.012-.14C80.435 17.273 62.591 0 40.705 0 18.224 0 0 18.224 0 40.705 0 63.186 18.224 81.41 40.705 81.41h.007l44.207.006c-.937-12.754-3.181-38.271-3.52-42.107zM11.845 55.48a32.369 32.369 0 01-3.561-14.807 32.345 32.345 0 013.743-15.15l25.777 15.138L11.845 55.48zm27.451 17.659c-10.932-.493-20.457-6.385-25.971-15.075l25.971-14.827v29.902zm0-35.054L13.535 22.957c5.545-8.51 14.967-14.262 25.761-14.749v29.877zm2.977 35.054V43.286l25.749 15.122c-5.546 8.5-14.962 14.244-25.749 14.731zm27.26-17.297L43.744 40.698l25.979-14.831a32.36 32.36 0 013.561 14.807 32.343 32.343 0 01-3.751 15.168z"
      />
    </svg>
  );
}

export default React.forwardRef(SvgSeg);
